import { Typography } from '@mui/material';

import { TableCellCustom } from '@app/components/table';
import { IDesignation } from '../types';
import { RowActions } from './row-actions';

interface Props {
  row: IDesignation;
  selected: boolean;
  onSelectRow: VoidFunction;
  canAddDesignation: string;
}

const DesignationRow = (props: Props) => {
  const { row, canAddDesignation } = props;

  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.name}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center" sx={{ maxWidth: 340, overflow: 'hidden' }}>
        <Typography variant="body2">{row.desc || 'NA'}</Typography>
      </TableCellCustom>
      {canAddDesignation ? (
        <TableCellCustom align="center" width={50}>
          <RowActions row={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { DesignationRow };
